import { BaseEntity } from './BaseEntity'

export class RHDigitalTeamEntity extends BaseEntity {
    constructor() {
        super()

        this.entityName = 'components.rhdigital.list.teams.entity'
        this.APIRoute = 'Resources/RHDigital/Teams'
        this.i18nBase = 'components.rhdigital.list.teams'
        this.customActions = { duplicate: false }

        this.pages = {
            create: { route: ['/rhdigital/teams'] },
            edit: { route: ['/rhdigital/teams'] },
            list: {
                pageTitle: 'components.rhdigital.list.teams.title',
                pathI18n: 'components.settings.permissionManagement.menuList.Teams',
                route: ['/rhdigital/teams'],
                filters: {
                    quickSearch: {
                        info: 'common.messages.info.searchByName',
                        searchBy: ['nome'],
                        type: 'text',
                    },
                    advanced: {
                        fields: [
                            {
                                key: 'status',
                                label: 'common.labels.status',
                                type: 'select',
                                options: [
                                    { label: 'common.labels.active', value: true },
                                    { label: 'common.labels.inactive', value: false },
                                ],
                                path: 'status',
                            },
                        ],
                    },
                },
            },
        }
    }
}
